(function () {
  document.addEventListener("DOMContentLoaded", () => {
    /* -----------------------------
       TABS
    ----------------------------- */
    const tabHolders = document.querySelectorAll("[data-tabs-holder]");
    tabHolders.forEach(holder => {
      const tabs = holder.querySelectorAll(".tab-link");
      const contents = holder.querySelectorAll(".tab-content");

      tabs.forEach(tab => {
        const activate = () => {
          const target = tab.dataset.tab;
          tabs.forEach(t => t.classList.remove("current"));
          contents.forEach(c => c.classList.remove("current"));
          tab.classList.add("current");
          const activeContent = holder.querySelector(`.tab-content-${target}`);
          if (activeContent) activeContent.classList.add("current");
        };

        tab.addEventListener("click", activate);
        tab.addEventListener("keydown", e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            activate();
          }
        });
      });
    });

    /* -----------------------------
       GRID SLIDER (scrollbar-like drag)
       - Works on mouse / touch / pen
       - No inertia; precise tracking
       - Disables snap while dragging
       - Does NOT interfere with forms/links
    ----------------------------- */
    const DRAG_THRESHOLD_PX = 6; // movement before we consider it a drag

    const isInteractive = (el) => {
      return !!el.closest('input, button, select, textarea, label, a, [data-no-drag]');
    };

    const sliders = document.querySelectorAll("[data-grid-slider]");
    sliders.forEach(slider => {
      // Optional arrows
      const wrapper = slider.closest(".grid-slider") || slider.closest("grid-slider") || slider.parentElement;
      const arrowsContainer = wrapper?.querySelector(".slider__arrows");
      const btnPrev = arrowsContainer?.querySelector(".slider__button--prev");
      const btnNext = arrowsContainer?.querySelector(".slider__button--next");

      if (btnPrev && btnNext) {
        btnPrev.addEventListener("click", () => {
          slider.scrollBy({ left: -slider.clientWidth * 0.8, behavior: "smooth" });
        });
        btnNext.addEventListener("click", () => {
          slider.scrollBy({ left: slider.clientWidth * 0.8, behavior: "smooth" });
        });
      }

      // Ensure children overflow horizontally (do this in CSS ideally)
      Array.from(slider.children).forEach(child => {
        if (!child.style.flex) child.style.flex = "0 0 auto";
      });

      // Precise drag state
      let pointerDown = false;   // pointer is down
      let dragging = false;      // we crossed threshold
      let startX = 0;
      let startScrollLeft = 0;
      let targetScrollLeft = 0;
      let rafId = 0;
      const LERP = 0.3; // smoothing factor (0.2–0.4 feels nice)

      const stopRAF = () => { if (rafId) cancelAnimationFrame(rafId); rafId = 0; };
      const animate = () => {
        const current = slider.scrollLeft;
        const next = current + (targetScrollLeft - current) * LERP;
        if (Math.abs(next - targetScrollLeft) < 0.25) {
          slider.scrollLeft = targetScrollLeft;
          rafId = 0;
          return;
        }
        slider.scrollLeft = next;
        rafId = requestAnimationFrame(animate);
      };

      const onPointerDown = (e) => {
        // Left click only (mouse). Touch/pen have no .button.
        if (e.button !== undefined && e.button !== 0) return;

        // If started on a form control or link, do NOT start drag
        if (isInteractive(e.target)) return;

        pointerDown = true;
        dragging = false; // will become true only after threshold
        startX = e.clientX;
        startScrollLeft = slider.scrollLeft;
        targetScrollLeft = startScrollLeft;
        stopRAF();

        if (slider.setPointerCapture && e.pointerId != null) {
          try { slider.setPointerCapture(e.pointerId); } catch(_) {}
        }
      };

      const onPointerMove = (e) => {
        if (!pointerDown) return;

        const dx = e.clientX - startX;

        // If we haven’t decided to drag yet, check threshold
        if (!dragging) {
          if (Math.abs(dx) < DRAG_THRESHOLD_PX) return; // still click territory
          dragging = true;
          slider.classList.add("is-dragging"); // disables snap via CSS
        }

        // Now we are dragging: prevent selection/dragging of content
        e.preventDefault();

        targetScrollLeft = startScrollLeft - dx; // 1:1 mapping like scrollbar

        if (!rafId) rafId = requestAnimationFrame(animate);
      };

      const onPointerUp = () => {
        if (!pointerDown) return;
        pointerDown = false;

        if (dragging) {
          // We were dragging; end drag state
          dragging = false;
          slider.classList.remove("is-dragging");
          // No momentum; let rAF finish easing to target
        } else {
          // We were not dragging (click); let the click go through
        }
      };

      if (window.PointerEvent) {
        slider.addEventListener("pointerdown", onPointerDown, { passive: true });
        slider.addEventListener("pointermove", onPointerMove, { passive: false });
        window.addEventListener("pointerup", onPointerUp, { passive: true });
        window.addEventListener("pointercancel", onPointerUp, { passive: true });
      } else {
        // Legacy fallback
        slider.addEventListener("mousedown", (e) => onPointerDown({ ...e, clientX: e.pageX }), { passive: true });
        window.addEventListener("mousemove", (e) => onPointerMove({ ...e, clientX: e.pageX, preventDefault: () => e.preventDefault() }), { passive: false });
        window.addEventListener("mouseup", onPointerUp, { passive: true });

        slider.addEventListener("touchstart", (e) => {
          const t = e.touches[0];
          onPointerDown({ ...e, clientX: t.clientX, target: e.target });
        }, { passive: true });

        slider.addEventListener("touchmove", (e) => {
          const t = e.touches[0];
          onPointerMove({ ...e, clientX: t.clientX, preventDefault: () => e.preventDefault() });
        }, { passive: false });

        slider.addEventListener("touchend", onPointerUp, { passive: true });
        slider.addEventListener("touchcancel", onPointerUp, { passive: true });
      }
    });
  });
})();

